import router from './router'
import store from './store'
import { Message } from 'element-ui'
import { getToken } from '@/utils/auth' // get token from cookie
import Cookies from 'js-cookie'
const { shouldCheckTimeZoneMismatch } = require('@/utils/h5Env')
const whiteList = ['/login', '/download', '/register', '/retrievePassword', '/forgetPassword', '/registerAccount', '/agreement', '/eAgreement', '/zAgreement'] // no redirect whitelist

router.beforeEach(async (to, from, next) => {
  // next()
  const hasToken = getToken()
  if (hasToken) {
    if (to.path === '/login') {
      if (to.fullPath.indexOf('&pwd=') > -1) {
        Cookies.remove('vue_admin_token')
        next({ path: '/login?account=' + to.query.account + '&pwd=' + to.query.pwd })
      } else {
        next({ path: '/' })
      }
    } else {
      const hasGetUserInfo = store.getters.userinfo
      // const hasGetUserInfo = '暂时没有'
      if (hasGetUserInfo.userId) {
        next()
      } else {
        try {
          // get user info
          await store.dispatch('user/getInfo', {
            checkTimeZone: shouldCheckTimeZoneMismatch(to.query, navigator.userAgent)
          })
          next({
            ...to,
            replace: true
          })
        } catch (error) {
          // remove token and go to login page to re-login
          await store.dispatch('user/resetToken')
          Message.error({ message: error || 'Has Error' })
          next(`/login?redirect=${to.path}`)
        }
      }
    }
  } else {
    /* has no token */
    if (whiteList.indexOf(to.path) !== -1) {
      // in the free login whitelist, go directly
      next()
    } else {
      // other pages that do not have permission to access are redirected to the login page.
      next(`/login?redirect=${to.path}`)
    }
  }
})

router.afterEach(() => {
  // finish progress bar
})
